import React from 'react';
import moment from 'moment';

const MonthEventField = ({ event }) => {
  const displayName = event.name || event.serviceName || '';
  const isWaitingList = event.waitingListPosition != null && event.waitingListPosition > 0;
  const formatTime = date => {
    if (!date) {
      return '';
    }
    const m = moment(date);
    const hour = m.hour();
    const minute = m.minute();

    if (minute === 0) {
      const displayHour = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
      return `${displayHour}${hour >= 12 ? 'p' : 'a'}`;
    } else {
      const displayHour = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
      const displayMinute = minute.toString().padStart(2, '0');
      return `${displayHour}:${displayMinute}${hour >= 12 ? 'p' : 'a'}`;
    }
  };

  const timeStr = formatTime(event.startTime);
  const eventColor = event.color || '#000';
  const eventStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    padding: '2px 4px',
    margin: '1px 0',
    borderRadius: '3px',
    fontSize: '11px',
    lineHeight: '1.2',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    width: '100%',
    backgroundColor: 'transparent',
  };

  const bulletStyle = {
    width: '6px',
    height: '6px',
    borderRadius: '50%',
    flexShrink: 0,
    backgroundColor: eventColor,
  };

  const textStyle = {
    flex: 1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    color: '#000',
  };

  return (
    <div
      style={eventStyle}
      data-type={event.type}
      data-waiting-list={isWaitingList}
      data-bought={event.isSessionBought || event.subscriptionId != null}
    >
      <span style={bulletStyle} />
      {timeStr && <span style={{ fontSize: '10px', fontWeight: 500, flexShrink: 0 }}>{timeStr}</span>}
      <span style={textStyle}>
        {displayName}
        {isWaitingList && <span style={{ fontSize: '9px', fontStyle: 'italic', marginLeft: '4px' }}>(Waiting List)</span>}
      </span>
      {event.capacity !== undefined && event.totalCapacity !== undefined && (
        <span style={{ fontSize: '9px', flexShrink: 0, marginLeft: 'auto' }}>{`${event.capacity ?? 0}/${event.totalCapacity}`}</span>
      )}
    </div>
  );
};

export default MonthEventField;
